import { Badge, IconButton, Shadow, Text, Icon, HStack, VStack } from '@genial/components';
import { BoxRadius, Color, Spacing, Typography } from '@genial/design-tokens';
import { Box, Pressable } from 'native-base';
import React, { useState } from 'react';
import { useRecoilValue } from 'recoil';

import { TableContentItemBadge } from '../../../../../../../../components/TableContent';
import { useConsortiumActions } from '../../../../../../../../store/consortium/actions';
import { customerConsortiumItemSelectedState } from '../../../../../../../../store/consortium/atom';

import { IsClosedLayoutResponsiveProps } from '.';

export const Mobile: React.FC<IsClosedLayoutResponsiveProps> = ({ title }) => {
  const { current: customer } = useRecoilValue(customerConsortiumItemSelectedState);
  const { updateCustomerStatus } = useConsortiumActions();

  const [sectionIsOpened, setSectionIsOpened] = useState(false);
  const toggleSection = () => setSectionIsOpened((state) => !state);

  return (
    <Shadow level={1} borderRadius={BoxRadius.sm}>
      <HStack
        p={Spacing['inline.xxxs']}
        borderRadius={BoxRadius.sm}
        justifyContent="space-between"
        alignItems="center"
        backgroundColor="neutral.white"
        {...(sectionIsOpened && { borderBottomRadius: 0 })}>
        <Text variant="semibold" fontSize={Typography['fontsize.md']}>
          {title}
        </Text>
        <HStack alignItems="center" space={Spacing['inline.nano']}>
          <Badge
            testId="badge-resume-batch-ticket"
            backgroundColor="feedback.success.default"
            textColor="neutral.white">
            Concluído
          </Badge>
          <IconButton
            icon={sectionIsOpened ? 'ChevronUp' : 'ChevronDown'}
            testId="section-toggle"
            p={0}
            onPress={toggleSection}
            iconColor={Color['neutral.black']}
          />
        </HStack>
      </HStack>
      {sectionIsOpened && (
        <VStack>
          <Box w="full" background="neutral.lightest" h={0.1} />
          <VStack p={Spacing['stack.xxxs']} space={Spacing['inline.xxxs']}>
            <HStack space={Spacing['inline.nano']} alignItems="center">
              <TableContentItemBadge>{customer?.suitabilityProfileName!}</TableContentItemBadge>
              <Text variant="regular">{customer?.name}</Text>
            </HStack>
            <VStack space={Spacing['inline.nano']}>
              <HStack alignItems="center" justifyContent="space-between">
                <Text color="neutral.dark">Saldo Disponível</Text>
                <Text>{customer?.availableBalanceFormatted}</Text>
              </HStack>
              <HStack alignItems="center" justifyContent="space-between">
                <Text color="neutral.dark">Situação cadastral</Text>
                <Text>{customer?.registrationStatusName}</Text>
              </HStack>
            </VStack>
            <Pressable w="full" variant="textLink" onPress={() => updateCustomerStatus('edit')}>
              <HStack alignItems="center" justifyContent="space-between">
                <Text variant="semibold" color="brand.tertiary.principal">
                  TROCAR CLIENTE
                </Text>
                <Icon name="Reverse" size="xxs" color={Color['brand.tertiary.principal']} />
              </HStack>
            </Pressable>
          </VStack>
        </VStack>
      )}
    </Shadow>
  );
};
